import React, {useState} from 'react';
import {Modal, Button} from 'react-bootstrap';

// Bootstrap モーダルで表示
const ModalView =() => {
    return (
      <>
              <div className="card mb-3 border-0">
                    <div className="row g-0">
                        <div className="col-md-12">
                            <div className="card-body">
                                <ul className="card-text">
                                    <li>
                                    四谷公開模試「組分けテスト」の指定月に於いて偏差値64以上の成績を収めたＹＴ生を対象とする。また、特待生については、ＹＴ教室の教室長の推薦とし、土佐塾本部の承認を得て特待生の適用を受けるものとする。よって、個人成績表(写し)の提出を必要とする。
                                    </li><br />
                                    <li>
                                    組分けテスト：3月、6月、9月、12月の年4回
                                    </li><br />
                                </ul>
                                <p>特待生特典…月々の月謝の半額を免除とする。</p>
                                <ul className="card-text">
                                    <li>
                                    期間は翌月より3ヶ月間とし、次回の組分けテスト指定月に於いて偏差値64以上を取得した場合は、その都度期間を3ヶ月間延長する事とする。また、これをくり返す。6年生は12月合不合判定テストで3月まで特待生扱いとする。
                                    </li><br />
                                    <li>
                                    特待生開始月以降の組分けテストで偏差値64未満の成績の場合は、その翌月より特待生制度の適用から外れる事となる。ただし、指定月の特待条件を満たさぬ場合も、指定月以前の2回の組分けテストに於いて、連続して上記成績内容を満たしている生徒については、室長の推薦により期間を3ヶ月延長することを認めることとする。
                                    </li>
                                </ul>
                                <p>
                                    注意事項）
                                    特待生制度は教室長の推薦によるため、学習態度、素行等に問題が生じた場合には、特待生制度の適用を取り消すことがある。
                                </p>
                            </div>
                        </div>
                    </div>
            </div>
      </>
    );
  }
  
const SystemTopClass = () => {
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Button variant="danger" onClick={handleShow}>
                 特待生制度とは?
             </Button>
  
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title> ＹＴ教室特待生制度</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <ModalView />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              閉じる
            </Button>
          </Modal.Footer>
        </Modal>
        </>
    );

};

export default SystemTopClass;
